enum DiscordOnboardingStatus {
  CheckingServer = "CheckingServer",
  Complete = "Complete",
  Connect = "Connect",
  Join = "Join",
}

export default DiscordOnboardingStatus;
